















import {Vue, Component, Prop} from "vue-property-decorator";
import {VueConstructor} from 'vue/types/vue';

import EmptyVueComponent from '@/views/components/EmptyVueComponent.vue';

@Component({
  name: "LeftDrawerLayout",
})
export default class LeftDrawer extends Vue {
  @Prop(Object)
  private drawerProps!: object;

  @Prop(Boolean)
  private visible!: boolean;

  @Prop({ default: EmptyVueComponent })
  private vueComponent!: VueConstructor;

  private closeDrawer() {
    this.$uiBus.emit("drawer:hide");
  }
}
